"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var routes_1 = require("../../routes");
var PartnersBlock = /** @class */ (function (_super) {
    tslib_1.__extends(PartnersBlock, _super);
    function PartnersBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartnersBlock.prototype.render = function () {
        var _a = this.props, items = _a.items, showPartnerTitle = _a.showPartnerTitle;
        return (react_1.default.createElement("div", { className: "partners-block" }, items.map(function (item) {
            var Tag = item.withLink ? 'a' : 'div';
            return (react_1.default.createElement(Tag, { key: item.name, title: item.name, href: item.withLink
                    ? routes_1.Routes.partners + "/" + item.slug.toLowerCase()
                    : undefined, className: "partners-block__item " + (item.withLink ? 'partners-block__item_active' : '') },
                react_1.default.createElement("div", { className: "partners-block__item-image-wrapper" },
                    react_1.default.createElement("img", { alt: item.name, className: "partners-block__item-image", src: item.logo.url })),
                showPartnerTitle && (react_1.default.createElement("div", { className: "partners-block__item-title" }, item.name))));
        })));
    };
    PartnersBlock = tslib_1.__decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], PartnersBlock);
    return PartnersBlock;
}(react_1.default.Component));
exports.PartnersBlock = PartnersBlock;
